import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  getAllInWorkspace(workspaceUid) {
    return raw.getAll(routes.sheetHistorySets.allInWorkspace(workspaceUid));
  },
  // Creates a new projected history set given a *parent* history set UID
  createInWorkspaceFromParent(workspaceUid, parentHistorySetUids) {
    return raw.post(routes.sheetHistorySets.allInWorkspace(workspaceUid), {
      parent_sheet_history_set_uids: parentHistorySetUids,
    });
  },
  // Creates a new projected history set given an _already projected_ **sheet** UID
  createInWorkspaceFromProjectedSheet(workspaceUid, projectedSheetUids) {
    return raw.post(routes.sheetHistorySets.allInWorkspace(workspaceUid), {
      sheet_uids: projectedSheetUids,
    });
  },
  deleteInWorkspace(workspaceUid, projectedSheetHistorySetUids) {
    return raw.delete({
      url: routes.sheetHistorySets.allInWorkspace(workspaceUid),
      params: {
        sheet_history_set_uids: projectedSheetHistorySetUids.join(","),
      },
    });
  },
};
